import KBaseMap from "@/components/Maps/KBaseMap";
import KStoreMarker from "../markers/KStoreMarker";
import KTruckMarker from "../markers/KTruckMarker";
import KTrucksMapAlertsSidebar from "../sidebars/KTrucksMapAlertsSidebar";
import KTrucksMapFollowButton from "../KTrucksMapFollowButton";
import KTrucksMapSidebar from "../sidebars/KTrucksMapSidebar";
import KTrucksMapTrafficLayer from "../KTrucksMapTrafficLayer";
import { Broadcastable, FetchesData } from "kinnect-mixins";
import { StoreLocation, YardTruckRoute } from "kinnect-models";

export default {
	name: "KAllTrucksMap",

	props: {
		storeModuleName: {
			required: true,
			type: String
		}
	},

	mixins: [
		Broadcastable,
		FetchesData
	],

	data: () => ( {
		stores: [],
		trucks: [],
		broadcasts: {
			Model: YardTruckRoute,
			channel: "truck-locations",
			propKey: "trucks",
			eventNames: { r: "update" }
		}
	} ),

	computed: {
		moduleRegistered() {
			return this.$store.state.hasOwnProperty( this.storeModuleName );
		},

		rootActiveMarker() {
			if ( this.moduleRegistered ) {
				return this.$store.state[this.storeModuleName].rootActiveMarker;
			}

			return null;
		},

		activeTruck() {
			if ( this.rootActiveMarker && this.rootActiveMarker.type === "truck" ) {
				return this.trucks.find( truck => truck.id === this.rootActiveMarker.id );
			}

			return null;
		}
	},

	methods: {
		async fetchTrucks() {
			this.trucks = await YardTruckRoute.get();
		},

		async fetchStores() {
			this.stores = await StoreLocation.get();
		},

		async fetch() {
			await this.$http.all( [
				this.fetchTrucks(),
				this.fetchStores()
			] );
		}
	},

	render() {
		return <KBaseMap
			fitMarkerTypeToBounds="truck"
			spiderfy
			storeModuleName={this.storeModuleName}
		>
			<KTrucksMapSidebar
				loading={this.fetching}
				slot="left-sidebar"
				trucks={this.trucks}
			></KTrucksMapSidebar>

			<KTrucksMapAlertsSidebar
				alerts={this.activeTruck && this.activeTruck.activeTrip ? this.activeTruck.activeTrip.alerts : undefined}
				loading={this.fetching}
				slot="right-sidebar"
			></KTrucksMapAlertsSidebar>

			<KTrucksMapFollowButton></KTrucksMapFollowButton>

			<KTrucksMapTrafficLayer></KTrucksMapTrafficLayer>

			{this.trucks.map( truck =>
				<KTruckMarker
					key={`truck-${truck.id}`}
					markerId={truck.id}
					truck={truck}
				></KTruckMarker>
			)}

			{this.stores.map( store =>
				<KStoreMarker
					key={`store-${store.name}`}
					store={store}
				></KStoreMarker>
			)}
		</KBaseMap>;
	}
};
